export default __webpack_public_path__ + "2e0402f0e7661bc61976e9bb2794b06d.svg";